import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

type Props = {
    permission: string;
    children?: React.ReactNode;
};

export default function RequirePermission({ permission, children }: Props) {
    const { user } = useAuth();
    const navigate = useNavigate();

    const ok = !!user?.permissions?.includes(permission);
    if (ok) return <>{children ?? null}</>;

    return (
        <Box>
            <Alert
                severity="error"
                variant="outlined"
                action={
                    <Button color="inherit" size="small" onClick={() => navigate('/dashboard')}>
                        Go to dashboard
                    </Button>
                }
            >
                You don’t have permission to view this page.
            </Alert>
        </Box>
    );
}

